import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { DbNumberInputProps } from './DbNumberInput.types';

// 尺寸配置
const sizeConfig = {
    small: {
        height: 24,
        width: 80,
        buttonWidth: 24,
        fontSize: 12,
        buttonFontSize: 14,
    },
    medium: {
        height: 28,
        width: 90,
        buttonWidth: 28,
        fontSize: 13,
        buttonFontSize: 16,
    },
    large: {
        height: 32,
        width: 104,
        buttonWidth: 32,
        fontSize: 14,
        buttonFontSize: 18,
    },
};

export const DbNumberInput: React.FC<DbNumberInputProps> = ({
    max = 10,
    min = 0,
    initialValue = 0,
    onChange,
    color,
    style,
    textStyle,
    size = 'small',
    type = 'bordered',
}) => {
    const [quantity, setQuantity] = useState(initialValue);
    const config = sizeConfig[size];
    const isBorderless = type === 'borderless';

    const handleDecrease = () => {
        if (quantity > min) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            onChange?.(newQuantity);
        }
    };

    const handleIncrease = () => {
        if (quantity < max) {
            const newQuantity = quantity + 1;
            setQuantity(newQuantity);
            onChange?.(newQuantity);
        }
    };

    return (
        <View style={[
            styles.container,
            {
                height: config.height,
                width: config.width,
                borderWidth: isBorderless ? 0 : 1,
            },
            isBorderless && styles.borderlessContainer,
            style,
        ]}>
            <TouchableOpacity
                style={[
                    styles.button,
                    {
                        width: config.buttonWidth,
                        height: config.height,
                    },
                    styles.leftButton,
                    !isBorderless && styles.borderedLeftButton,
                    quantity <= min && styles.disabledButton,
                ]}
                onPress={handleDecrease}
                disabled={quantity <= min}
                activeOpacity={0.7}
            >
                <Text style={[
                    styles.buttonText,
                    { fontSize: config.buttonFontSize },
                    color ? { color } : styles.primaryText,
                    quantity <= min && styles.disabledText,
                ]}>-</Text>
            </TouchableOpacity>
            <Text style={[
                styles.quantityText,
                {
                    fontSize: config.fontSize,
                    height: config.height,
                    lineHeight: config.height,
                },
                color ? { color } : styles.primaryText,
                textStyle,
            ]}>{quantity}</Text>
            <TouchableOpacity
                style={[
                    styles.button,
                    {
                        width: config.buttonWidth,
                        height: config.height,
                    },
                    styles.rightButton,
                    !isBorderless && styles.borderedRightButton,
                    quantity >= max && styles.disabledButton,
                ]}
                onPress={handleIncrease}
                disabled={quantity >= max}
                activeOpacity={0.7}
            >
                <Text style={[
                    styles.buttonText,
                    { fontSize: config.buttonFontSize },
                    color ? { color } : styles.primaryText,
                    quantity >= max && styles.disabledText,
                ]}>+</Text>
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 4,
        borderColor: '#e5e5e5',
        overflow: 'hidden',
        backgroundColor: '#fff',
    },
    borderlessContainer: {
        backgroundColor: 'transparent',
    },
    button: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f7f7f7',
    },
    leftButton: {
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
    },
    borderedLeftButton: {
        borderRightWidth: 1,
        borderRightColor: '#e5e5e5',
    },
    rightButton: {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
    },
    borderedRightButton: {
        borderLeftWidth: 1,
        borderLeftColor: '#e5e5e5',
    },
    disabledButton: {
        backgroundColor: '#f0f0f0',
    },
    buttonText: {
        fontWeight: 'bold',
        color: '#222',
    },
    disabledText: {
        color: '#ccc',
    },
    quantityText: {
        flex: 1,
        textAlign: 'center',
        color: '#222',
        backgroundColor: '#fff',
    },
    primaryText: {
        color: '#222',
    },
});

export default DbNumberInput;
